import { render, staticRenderFns } from "./TrainingVideoDialog.vue?vue&type=template&id=1ab40555&scoped=true&"
import script from "./TrainingVideoDialog.vue?vue&type=script&lang=js&"
export * from "./TrainingVideoDialog.vue?vue&type=script&lang=js&"
import style0 from "../../company/statistics/css/commonCompany.css?vue&type=style&index=0&id=1ab40555&scoped=true&lang=css&"
import style1 from "./TrainingVideoDialog.vue?vue&type=style&index=1&id=1ab40555&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab40555",
  null
  
)

export default component.exports